import React, {useState} from 'react'
import styled from '@emotion/styled'
import {Folder} from '../../assets/icons/folder'
import {OpenFolder} from '../../assets/icons/openFolder'
import {Link, useLocation, useNavigate} from 'react-router-dom'
import useChangeRoutPath from '../../hooks/changeRoutPath'
import {NAVIGATION} from '../../constants/pathName'
import {useAppDispatch, useAppSelector} from '../../hooks/redux'
import {getSubjectId} from '../../pages/biomarkers/[id]/IndicatorsAndSignals'
import {MAX_URL_LENGTH} from '../../pages/subjects/SubjectEdit'
import {Button, Modal} from "@mui/material";
import {Box} from "@mui/system";
import Typography from "@mui/material/Typography";
import CloseIcon from '@mui/icons-material/Close';
import {patchRemove} from "../../redux/slice/data";

const LinkStyle = styled(Link)<{ active: string }>`
  display: flex;
  cursor: pointer;
  padding: 8px;
  margin: 2px 8px;
  transition: all .4s ease;

  &:hover {
    background-color: var(--light-transparent-10, rgba(255, 255, 255, 0.1));
    border-radius: 5px;
  }

  text-decoration: none;

  ${({active}) =>
          active === 'true' &&
          `
    background-color: var(--light-transparent-10, rgba(255, 255, 255, 0.1));
    border-radius: 5px;`}
`

const Text = styled.p`
  color: white;
  margin: 0 0 0 10px;
`
export const RemoveBtn = (props: any) => {
    const _style = {
        ...props.top ? {'marginTop': props.top + 'px!important'} : {},
        ...props.right ? {'marginRight': props.right + 'px'} : {},
        ...props.absTop ? {'top': props.absTop + 'px'} : {},
    }
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const style = {
        position: 'absolute' as 'absolute',
        top: '200px',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        outline: 'none',
        border: 'none',
        boxShadow: 24,
        p: 4,
    };

    let isEditor = (global as any)?.isEditor;


    if (!isEditor) {
        return null;
    }
    return <><div className={'remove-btn '  + props.color + ' ' + (props.relative ? 'rel' : '')} style={{..._style}} onClick={(e) => {
        setTimeout(() => {
            handleOpen()
        })
        //

        e.preventDefault();
        e.stopPropagation();
        return null;
    }}><CloseIcon style={{fontSize: '15px', marginTop: '7px', }}></CloseIcon>

    </div> <div onClick={(e) => {
        e.stopPropagation();
        return null;
    }}>
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Are you sure to remove {typeof props.name === 'object' 
                        ? props.name?.en || props.name?.[Object.keys(props.name || {})[0]] || '-'
                        : props.name || '-'}?
                    <br/>
                </Typography>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    <button onClick={() => {
                        handleClose();
                        props.onClick && props.onClick()
                    }} className={'btn'}>Yes</button>
                    <button className={'btn btn-no'} style={{marginLeft: '5px'}} onClick={handleClose}>No</button>
                </Typography>
            </Box>
        </Modal>
    </div>
    </>
}

const ListMenu = ({search}: { search: string }) => {
    const {subjects} = useAppSelector((state) => state.data)
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const _subjects = Object.values(subjects);
    let subjectId = getSubjectId()
    return (
        <>
            {_subjects
                .filter((subject) => (search ? subject?.name?.includes(search) : true))
                .map((item: any, index: number) => {

                    let subject = item._id
                    let isActive = subject == subjectId
                    return (
                        <LinkStyle
                            data-theme-item
                            onClick={(e) => e.stopPropagation()}
                            to={'/' + subject + '/' + NAVIGATION.INDACATORS_SIGNALS.url}
                            key={index}
                            active={isActive + ''}
                        >
                            {isActive ? <OpenFolder/> : <Folder/>}
                            <Text>
                                {item?.name?.en?.slice(0, MAX_URL_LENGTH)} 
                                {item?.name?.en?.slice(MAX_URL_LENGTH)?.length > 0 && ' ...'}
                            </Text>
                            <RemoveBtn
                                color={'black'}
                                name={typeof item.name === 'object' 
                                    ? item.name?.en || item.name?.[Object.keys(item.name || {})[0]] || ''
                                    : item.name || ''}
                                top={-8} onClick={() => {
                                    dispatch(patchRemove({_id: item._id, type: 'subjects'}))
                                    if (item._id == getSubjectId()) {
                                        let __subjects = _subjects.filter(it => it._id != item._id)
                                        let subj0 = (__subjects[0] || {})._id;
                                        let redirectUrl = subj0 ? ( '/' + subj0 + '/') : '/create-theme';
                                        console.log('redirectUrl', redirectUrl)
                                        navigate(redirectUrl)
                                    }
                            }}></RemoveBtn>
                        </LinkStyle>
                    )
                })}
        </>
    )
}

export default ListMenu
